import { render, staticRenderFns } from "./relevancyList.vue?vue&type=template&id=539b8910&"
import script from "./relevancyList.vue?vue&type=script&lang=js&"
export * from "./relevancyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports